import { getClientInfo } from '@/constants/utils/analytics';
import { fetchWithAuth, ApiError } from './client';

export async function refreshToken(token, { refreshRequestId } = {}) {
  let clientInfo;
  try { clientInfo = getClientInfo(); } catch (_) {}
  const data = await fetchWithAuth('/json/auth/refresh-token', {
    method: 'POST', body: { refreshToken: token, ...(refreshRequestId && { refreshRequestId }), ...(clientInfo && { clientInfo }) },
  });
  if (data.error) throw new ApiError(data.message || 'Refresh rejected', 401, data);
  const expiresAt = new Date(data.tokens?.expiresAt);
  if (!data.tokens?.access || !data.tokens?.refresh || !Number.isFinite(expiresAt.getTime())) {
    throw new ApiError('Invalid token refresh response', 502);
  }
  return { accessToken: data.tokens.access, refreshToken: data.tokens.refresh, expiresAt };
}
